import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTypedSelector } from '../../redux/Hooks/storeSelectors';
import { selectMapLayerIdByEntityName } from '../../redux/selectors/selectors';
import EntityManagerCleaner from '../entities/EntityManagerCleaner';
import EntityEditor from '../entities/EntityEditor';
import { ScenarioEventsEntityName } from '@api/types/types';

const NetworkEventEdit = () => {
    const entityName = ScenarioEventsEntityName.NetworkEvent;
    const { networkEventId } = useParams<any>();
    const stopsLayerId = useTypedSelector(state => selectMapLayerIdByEntityName(state, entityName));

    const onSaveFn = useCallback(
        (entity: any) => {
            if (!networkEventId) {
                return `../${entity.id}/edit`;
            }
        },
        [networkEventId]
    );

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={networkEventId!}
                entityName={entityName}
                layerId={stopsLayerId}
                presetProperty={'scenarioCasePreset'}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!networkEventId}
            />
        </EntityManagerCleaner>
    );
};

export default NetworkEventEdit;
